import React, { useState, useMemo } from 'react';
import CalcShell from '../CalcShell';

// Full IANA-style time-zone list with offset & city label for display.
const ZONES = [
  { v:-12, n:'(UTC−12) Baker Island, Howland Island' },
  { v:-11, n:'(UTC−11) Samoa Standard Time — Pago Pago' },
  { v:-10, n:'(UTC−10) Hawaii-Aleutian ST — Honolulu' },
  { v:-9,  n:'(UTC−9) Alaska Standard Time — Anchorage' },
  { v:-8,  n:'(UTC−8) Pacific Standard Time — Los Angeles, Vancouver' },
  { v:-7,  n:'(UTC−7) Mountain Standard Time — Denver, Phoenix' },
  { v:-6,  n:'(UTC−6) Central Standard Time — Chicago, Mexico City' },
  { v:-5,  n:'(UTC−5) Eastern Standard Time — New York, Toronto' },
  { v:-4,  n:'(UTC−4) Atlantic Standard Time — Halifax, Santiago' },
  { v:-3.5,n:'(UTC−3:30) Newfoundland Standard Time — St. John\'s' },
  { v:-3,  n:'(UTC−3) Argentina, Brazil (São Paulo)' },
  { v:-2,  n:'(UTC−2) Fernando de Noronha, South Georgia' },
  { v:-1,  n:'(UTC−1) Azores, Cape Verde' },
  { v:0,   n:'(UTC±0) GMT — London, Dublin, Lisbon, Reykjavík' },
  { v:1,   n:'(UTC+1) Central European Time — Berlin, Paris, Rome, Madrid' },
  { v:2,   n:'(UTC+2) Eastern European Time — Cairo, Athens, Kyiv' },
  { v:3,   n:'(UTC+3) Moscow, Istanbul, Nairobi, Riyadh' },
  { v:3.5, n:'(UTC+3:30) Iran Standard Time — Tehran' },
  { v:4,   n:'(UTC+4) Gulf Standard Time — Dubai, Baku' },
  { v:4.5, n:'(UTC+4:30) Afghanistan Standard Time — Kabul' },
  { v:5,   n:'(UTC+5) Pakistan Standard Time — Karachi, Tashkent' },
  { v:5.5, n:'(UTC+5:30) India Standard Time — Kolkata, Mumbai, Delhi, Colombo' },
  { v:5.75,n:'(UTC+5:45) Nepal Standard Time — Kathmandu' },
  { v:6,   n:'(UTC+6) Bangladesh Standard Time — Dhaka' },
  { v:6.5, n:'(UTC+6:30) Myanmar Standard Time — Yangon' },
  { v:7,   n:'(UTC+7) Indochina Time — Bangkok, Jakarta, Ho Chi Minh City' },
  { v:8,   n:'(UTC+8) China / Singapore / Malaysia — Beijing, Singapore, Perth' },
  { v:8.75,n:'(UTC+8:45) Australian Central Western — Eucla' },
  { v:9,   n:'(UTC+9) Japan Standard Time — Tokyo, Seoul' },
  { v:9.5, n:'(UTC+9:30) Australian Central ST — Adelaide, Darwin' },
  { v:10,  n:'(UTC+10) Australian Eastern ST — Sydney, Melbourne, Brisbane' },
  { v:10.5,n:'(UTC+10:30) Lord Howe Island' },
  { v:11,  n:'(UTC+11) Solomon Islands, New Caledonia' },
  { v:12,  n:'(UTC+12) New Zealand Standard Time — Auckland, Fiji' },
  { v:12.75,n:'(UTC+12:45) Chatham Standard Time' },
  { v:13,  n:'(UTC+13) Tonga, Samoa' },
  { v:14,  n:'(UTC+14) Line Islands — Kiritimati' }
];

export default function TimeZoneCalc() {
  const [dt, setDt] = useState(() => new Date().toISOString().slice(0, 16));
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(-5);
  const [q, setQ] = useState('');

  const c = useMemo(() => {
    const d = new Date(dt);
    const shifted = new Date(d.getTime() + (to - from) * 3600000);
    return shifted;
  }, [dt, from, to]);

  const filtered = q ? ZONES.filter(z => z.n.toLowerCase().includes(q.toLowerCase())) : ZONES;

  return (
    <CalcShell look="cnet" title="Time Zone Calculator" subtitle="Convert a date & time between any two named time zones, including half-hour and 45-minute offsets.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>Date &amp; Time</label><input type="datetime-local" value={dt} onChange={e => setDt(e.target.value)}/></div>
          <div className="field"><label>Search zones</label><input value={q} onChange={e => setQ(e.target.value)} placeholder="e.g. India, London, Tokyo…"/></div>
          <div className="field"><label>From Time Zone</label>
            <select value={from} onChange={e => setFrom(+e.target.value)} data-testid="tz-from">
              {filtered.map(z => <option key={z.v} value={z.v}>{z.n}</option>)}
            </select>
          </div>
          <div className="field"><label>To Time Zone</label>
            <select value={to} onChange={e => setTo(+e.target.value)} data-testid="tz-to">
              {filtered.map(z => <option key={z.v} value={z.v}>{z.n}</option>)}
            </select>
          </div>
        </div>
        <div>
          <div className="result-panel"><div className="result-title">Converted Time</div><div className="result-value text-2xl" data-testid="tz-result">{c.toLocaleString(undefined, { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' })}</div></div>
          <div className="text-sm text-slate-500 mt-3">Offset difference: {(to - from >= 0 ? '+' : '') + (to - from).toFixed(2)} hours</div>
        </div>
      </div>
    </CalcShell>
  );
}
